import { CurveMethod } from '@Types/deteriorationModels.types';

export type WeibullFallbackVariant = 'fit-unavailable' | 'not-applicable';

export interface WeibullFallbackInput {
	fallback?: boolean;
	deteriorationMethod: CurveMethod;
}

export interface WeibullFallbackSignal {
	variant: WeibullFallbackVariant;
}

// industry-standard and one-expected-life curves are 2-parameter by design, so a 3p selection
// collapsing to 2p there is "not applicable" rather than a failed fit.
const NOT_APPLICABLE_METHODS: ReadonlySet<CurveMethod> = new Set([
	CurveMethod.INDUSTRY_CURVE,
	CurveMethod.ONE_EXPECTED_LIFE,
]);

export const getWeibullFallbackSignal = (input: WeibullFallbackInput): WeibullFallbackSignal | null => {
	if (input.fallback !== true) {
		return null;
	}
	if (NOT_APPLICABLE_METHODS.has(input.deteriorationMethod)) {
		return { variant: 'not-applicable' };
	}
	return { variant: 'fit-unavailable' };
};
